$(document).ready(function(){
  if(window.location.href.includes("/products/")){
    
    
    //compatibility with gallery using remodal
//     var lightboxGallery = {
//       init: function(){
//         //compatibility with gallery using remodal
//         if ($('.lightbox img').length) {
//           var currentSlide;
//           var $lightboxImages = $('a.lightbox');
//           var groups = [];

//           //get all lightbox images and divide into groups based on rel attribute
//           $lightboxImages.each(function(index){

//             groups.push($(this).attr('rel'));
//             groups = groups.filter(function(item, i, ar){ return ar.indexOf(item) === i; });
//           })

//           //loop through gallery groups and create modals
// //           $.each(groups, function(index, value){

// //             //Loop through images and add link to remodal
// //             console.log("value ::",value);
// //             $('.lightbox[rel=' + value + ']').attr('data-remodal-target', 'lightbox-id-' + index );

// //             var lightboxModal = [
// //               '<div class="remodal remodal-lightbox js-remodal-lightbox js-lightbox-' + index + '" data-rel="' + value + '" data-remodal-id="lightbox-id-' + index + '" data-remodal-options="hashTracking: false">',
// //               '<a data-remodal-action="close" class="remodal-close"></a>',
// //               '<div class="lightbox-gallery"></div>',
// //               '</div>'
// //             ].join('');

// //             //Add modal lightbox to page to be populated by lightboxImageGallery
// //             $('body').append(lightboxModal);

// //             $('.lightbox[rel=' + value + ']').each(function(index){
// //               $(this).attr('data-image-id', index);
// //               $(this).attr('data-no-instant', '');
// //             });

// //           });

//         }
//       }
//     }
    
    
    
    function add_swatch_images(stone_type,metal,product_id){
      
      var images = stone_type +" | "+ metal;

      var images = $('#select-product-images--'+product_id+' option[data-image-handleize-alt="'+images+'"]'),
          enable_product_lightbox = $("#hidden-element--"+product_id).data("enable_product_lightbox"),
          zoom = $("#hidden-element--"+product_id).data("zoom"),
          template = $("#hidden-element--"+product_id).data("template"),
          autoplay = $("#hidden-element--"+product_id).data("autoplay"),
          div_class = $(".product-"+product_id+"-gallery").attr("class"),
          class_array = div_class.split(" ");
      	  class_array.splice($.inArray("flickity-enabled", class_array), 1),
          class_array.splice($.inArray("is-draggable", class_array), 1);
      var div_classes = class_array.join(" ");
      
      //console.log("Imahes",images)
      if(images.length > 0){
      var Image_array = [];
      images.each(function(i){
        var height = $(this).data("height"),
            index = $(this).data('index'),
            width = $(this).data("width"),
            image_url = $(this).data("image-url"),
            title = $(this).data("stone-type"),
            alt = $(this).data("alt"),
            image_id = $(this).data("image-id"),
            data_metal = $(this).data("metal"),
            loading_style = "fade-in";

            var sizes = "auto";
        if(enable_product_lightbox == true){
          sizes="100vw";
        }

        var image_html = '<div class="gallery-cell" data-alt="'+alt+'" data-title="'+alt+'" data-image-height="'+height+'" data-image-width="'+width+'">';
        if(template != 'index' && enable_product_lightbox == true){
          image_html += '<a href="'+image_url+'" class="lightbox" rel="gallery" data-fancybox-group="gallery" data-lightbox-zoom="'+zoom+'">';
        }
        image_html += '<div class="image__container" style="max-width:'+width+'">';
        image_html += '<img src="'+image_url+'"  alt="'+alt+'" class=" lazyload '+loading_style+'" data-index="'+index+'" data-image-id="'+image_id+'" data-sizes="'+sizes+'" data-handleize-alt="'+data_metal+'" data-src="'+image_url+'" />';

        image_html += '</div>';
        if(template != 'index' && enable_product_lightbox == true){
          image_html += '</a>';
        }
        image_html += '</div>';

        Image_array.push(image_html);
        //         console.log(image_html);
      });

      var final_html = '<div class="'+class_array.join(" ")+'" data-zoom="'+zoom+'" data-autoplay="'+autoplay+'">';
      final_html += Image_array.join(" ");
      final_html += '</div>';

      $(".product-"+ product_id +"-gallery").replaceWith(final_html);

      var draggable = true;
      var prevNextButtons = true;
      var autoplay = $('.product_gallery').data('autoplay');

      if ($('.product_gallery').hasClass('single-image')){
        draggable = false;
        prevNextButtons = false;
      }

      
      //used for settings.slideshow_arrow_size === 'regular'
      var arrowSize = {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
      

      $('.product_gallery').flickity({
        "adaptiveHeight": true,
        "wrapAround": "true",
        "cellAlign": "left",
        "draggable": draggable,
        "contain": true,
        "imagesLoaded": true,
        "lazyLoad": 2,
        "pageDots": false,
        "prevNextButtons": prevNextButtons,
        "autoPlay": autoplay ? 6000 : false,
        "selectedAttraction": 0.01,
        "friction": 0.15,
        "arrowShape": arrowSize
      });
      
        //initialize lightbox
    lightboxGallery.init();
        
        }
    }
    
    $(document).on("click",".swatch_options [name='option-0']",function(){
      var stone_type = $(this).data("handleize-value"),
          product_id = $(this).data("product-id"),
          selected_metal = $('[name="option-1"]:checked').data("handleize-value");
      
      add_swatch_images(stone_type,selected_metal,product_id);
      
      //console.log("handleize_value ::",stone_type,"product_id::",product_id,"selected_metal ::",selected_metal)
      
    });
    
      $(document).on("click",".swatch_options [name='option-1']",function(){
      var metal = $(this).data("handleize-value"),
          product_id = $(this).data("product-id"),
          selected_stone_type = $('[name="option-0"]:checked').data("handleize-value");
      
        add_swatch_images(selected_stone_type,metal,product_id);
        
      //console.log("handleize_value ::",metal,"product_id::",product_id,"selected_metal ::",selected_stone_type)
      
    });
    
    $(document).on("click",".swatch_options [name='option-1']",function(){
      var handleize_value = $(this).data("handleize-value");
      var varinat_image = $(".product_gallery .gallery-cell .image__container img[data-handleize-alt='"+handleize_value+"']");
      if(varinat_image.length == 1){
        var image_index = varinat_image.data("index");
        //console.log("hiii",varinat_image.length,handleize_value,image_index)
        var $slider = $('.product_gallery');
        $slider.flickity( 'select', parseInt(image_index), false, true);
      }
    });
    
  }
});